module.exports = __webpack_public_path__ + "img/behaviour2.d02851f.jpg";